<div class="flex h-screen bg-gray-50">
  <!-- Drawer Sidebar -->
  <aside
    class="kt-drawer kt-drawer-start w-64 shadow-lg border-r 
           flex-shrink-0 flex flex-col"
    data-kt-drawer="true"
    data-kt-drawer-width="256px"
    data-kt-drawer-direction="start"
    data-kt-drawer-toggle="#drawer"
    data-kt-drawer-overlay="false"
  >
    <div class="px-4 py-3 text-lg font-semibold  border-b ">
      Admin Panel
    </div>

    <div class="p-4 flex-1 overflow-y-auto">
  <div class="flex flex-col space-y-3">
    <button
      kendoButton
      [toggleable]="true"
      fillMode="outline"
      class="w-full text-left px-4 py-2 text-sm rounded hover:bg-blue-50"
      (click)="switchSection(adminSectionEnum.LogoManager)"
    >
      Logos
    </button>

    <button
      kendoButton
      [toggleable]="true"
      fillMode="outline"
      class="w-full text-left px-4 py-2 text-sm rounded hover:bg-blue-50 dark:hover:bg-gray-700"
      (click)="switchSection(adminSectionEnum.Events)"
    >
      Events
    </button>

    <button
      kendoButton
      [toggleable]="true"
      fillMode="outline"
      class="w-full text-left px-4 py-2 text-sm rounded hover:bg-blue-50 dark:hover:bg-gray-700"
      (click)="switchSection(adminSectionEnum.Products)"
    >
      Product Name
    </button>

    <button
      kendoButton
      [toggleable]="true"
      fillMode="outline"
      class="w-full text-left px-4 py-2 text-sm rounded hover:bg-blue-50 dark:hover:bg-gray-700"
      (click)="switchSection(adminSectionEnum.Sponsor)"
    >
      Sponsor Type
    </button>

    <button
      kendoButton
      [toggleable]="true"
      fillMode="outline"
      class="w-full text-left px-4 py-2 text-sm rounded hover:bg-blue-50 dark:hover:bg-gray-700"
      (click)="switchSection(adminSectionEnum.Imo)"
    >
      IMO Type
    </button>
  </div>
</div>

  </aside>

  <!-- Main Content -->
  <main class="flex-1 p-4 overflow-y-auto" [ngSwitch]="currentSection">
    <gd-logo-manager *ngSwitchCase="adminSectionEnum.LogoManager"></gd-logo-manager>
    <gd-events *ngSwitchCase="adminSectionEnum.Events"></gd-events>
    <gd-products *ngSwitchCase="adminSectionEnum.Products"></gd-products>
    <gd-sponsor *ngSwitchCase="adminSectionEnum.Sponsor"></gd-sponsor>
    <gd-imo *ngSwitchCase="adminSectionEnum.Imo"></gd-imo>
  </main>
</div>
